import { render } from "./ProfileIFrame.vue?vue&type=template&id=931b8ff0&ts=true"
import script from "./ProfileIFrame.ts?vue&type=script&lang=ts&external"
export * from "./ProfileIFrame.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__